var map = {
	"./1AGP.png": 62819,
	"./2AGP.png": 6280,
	"./3AGP.png": 77172,
	"components/Catalog/AGP/img/glass/z/zPlusGold/1AGP.png": 62819,
	"components/Catalog/AGP/img/glass/z/zPlusGold/2AGP.png": 6280,
	"components/Catalog/AGP/img/glass/z/zPlusGold/3AGP.png": 77172
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48395;